import {useMemo} from 'react';
import {EnrichedAstNode} from 'rendition-core';

export const useNodeChildrenIds = (node: EnrichedAstNode) => {
    const {flexNodes, absolutePositionedNodes} = useNodeChildren(node);

    return {
        flexNodes: flexNodes.map((node) => node.internalId),
        absolutePositionedNodes: absolutePositionedNodes.map((node) => node.internalId),
    };
};

export const useNodeChildren = (node: EnrichedAstNode) => {
    const absolutePositionedNodes = useMemo(
        () => node.children.filter((node) => node.calculatedLayoutAbstraction.absolutePosition),
        [node.children]
    );
    const flexNodes = useMemo(
        () => node.children.filter((node) => !node.calculatedLayoutAbstraction.absolutePosition),
        [node.children]
    );

    return {
        flexNodes,
        absolutePositionedNodes,
    };
};
